import GcHeading from '@garmin/components-global/src/components/GcHeading/index.vue';
import GcCopy from '@garmin/components-global/src/components/GcCopy/index.vue';
import PcLayoutContainer from '../PcLayoutContainer/index.vue';
import PcColumnLayout from '../PcColumnLayout/index.vue';

export default {
  name: 'PcOverviewIntro',
  props: {
    title: {
      type: String,
      default: '',
    },
    titleHeading: {
      type: String,
      default: 'h2',
    },
    titleAlign: {
      type: String,
      default: 'center',
    },
    description: {
      type: String,
      default: '',
    },
    descriptionAlign: {
      type: String,
      default: 'center',
    },
    descriptionSize: {
      type: String,
      default: 'large',
    },
    theme: {
      type: String,
      default: 'light',
    },
  },
  components: {
    PcLayoutContainer,
    PcColumnLayout,
    GcHeading,
    GcCopy,
  },
};
